const initialState = { filter_form_updated: false, FilterForm_reducer: [], filter_used: ''};

export function addFilterForm(state = initialState, action) {
    switch (action.type) {
        case 'ADD_FILTER_FORM':
            return {
                filter_form_updated: true,
                FilterForm_reducer: action.payload,
                filter_used: action.filter_used
            };
        case 'REMOVE_FILTER_FORM':
            return {
                ...initialState,
                filter_form_updated: false
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyse/AssessorList/add_filter_form.reducer.js